/** Requests the translation file at `url`. Every translation file request
 *  goes through here; `signal` is its only request option. */
export const fetchTranslationFile = (
  url: string,
  { signal }: { signal?: AbortSignal } = {}
): Promise<Response> => fetch(url, { signal: signal ?? null });
